import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_LIST_CUSTOMER,
  GET_DETAIL_CUSTOMER,
  LICH_SU_GIAO_DICH_CUSTOMER,
  GET_AUTOCOMPLETE_CUSTOMER,
} from "actions/Customer/actionTypes";
import {
  getListCustomerSuccess,
  getListCustomerFailure,
  getDetailCustomerSuccess,
  getDetailCustomerFailure,
  lichSuGiaoDichFailure,
  lichSuGiaoDichSuccess,
  getAutocompleteCustomerSuccess,
  getAutocompleteCustomerFailure,
} from "actions/Customer";
import { pushNotification } from "utils/notifications";
import CustomerApi from "service/customerApi";

function* getListCustomer(action) {
  try {
    const response = yield call(CustomerApi.List, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getListCustomerFailure());
      } else {
        yield put(getListCustomerSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getListCustomerFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getListCustomerFailure());
  }
}
function* getDetailCustomer(action) {
  try {
    const response = yield call(CustomerApi.detail, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getDetailCustomerFailure());
      } else {
        yield put(getDetailCustomerSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getDetailCustomerFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getDetailCustomerFailure());
  }
}

function* lichSuGiaoDich(action) {
  try {
    const response = yield call(CustomerApi.lichSuGiaoDich, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(lichSuGiaoDichFailure());
      } else {
        yield put(lichSuGiaoDichSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(lichSuGiaoDichFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(lichSuGiaoDichFailure());
  }
}
function* getAutocompleteCustomer(action) {
  try {
    const response = yield call(CustomerApi.Autocomplete, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getAutocompleteCustomerFailure());
      } else {
        yield put(getAutocompleteCustomerSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getAutocompleteCustomerFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getAutocompleteCustomerFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CUSTOMER, getListCustomer);
  yield takeLatest(GET_AUTOCOMPLETE_CUSTOMER, getAutocompleteCustomer);
  yield takeLatest(GET_DETAIL_CUSTOMER, getDetailCustomer);
  yield takeLatest(LICH_SU_GIAO_DICH_CUSTOMER, lichSuGiaoDich);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
